import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ViewOption {
  value: string;
  label: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'ss-view-toggle',
  templateUrl: './view-toggle.component.html',
  standalone: false
})
export class ViewToggleComponent {
  @Input() value = 'table';
  @Input() label = 'Visualização';
  @Input() options: ViewOption[] = [
    { value: 'table', label: 'Tabela', icon: 'list' },
    { value: 'chart', label: 'Gráfico', icon: 'chart-column' }
  ];
  @Input() variant: 'icon' | 'labeled' = 'icon';
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();

  select(option: ViewOption) {
    if (this.disabled || option.disabled || option.value === this.value) return;
    this.value = option.value;
    this.valueChange.emit(option.value);
  }
}
